<template>
  <div class="right">
    <div class="field_left">
      <text-input id="serviceWeightCategoryname"
                  :required="true"
                  v-model="entity.name"
                  :disabled="!isEditable"
                  ref="nameref"
      >
        <translate class="translate">Název</translate>

      </text-input>
    </div>
    <div class="field_right">
      <text-input id="serviceWeightCategoryvalue"
                  :required="true"
                  :disabled="!isEditable"
                  v-model="entity.value"
                  ref="valueref"
      >
        <translate class="translate">Váha</translate>
      </text-input>
    </div>

    <textarea-input id="serviceweightcategorynote" rows=6 cols=50 v-model="entity.note" ref="noteref" :disabled="!isEditable">
      <translate class="translate">Poznámka</translate>
    </textarea-input>
  </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "ServiceWeightCategoryBasicForm",
  components: {TextInput},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  methods: {
    validateServiceWeightCategoryFormRequiredFields() {
      let nameError = null
      let valueError = null

      if (!this.entity.name) {
        nameError = this.$gettext('Zadejte název')
      }

      if (!this.entity.value && this.entity.value !== 0) {
        valueError = this.$gettext('Zadejte váhu')
      }

      if (nameError !== null) {
        this.setFieldInvalid('nameref', true, nameError)
      } else {
        this.setFieldInvalid('nameref')
      }

      if (valueError !== null) {
        this.setFieldInvalid('valueref', true, valueError)
      } else {
        this.setFieldInvalid('valueref')
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/serviceWeightCategories/forms/ServiceWeightCategoryBasicForm.vue